export default __webpack_public_path__ + "static/media/resources-header.edc6fcba.jpeg";